module.exports = __webpack_public_path__ + "static/media/maisa_02.13fee21f.jpg";